import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { nativePushAvailable, listenForPushNavigation } from '@/lib/nativePush';

/**
 * Unsichtbare Root-Komponente (App.tsx): navigiert beim Tap auf eine
 * APNs-Notification zum Klick-Ziel (z. B. /admin/reservierungen).
 * Im Web und in Shells ohne Push-Plugin ein No-op.
 *
 * navigate läuft über eine Ref: der Listener wird genau einmal registriert
 * statt bei jeder navigate-Referenzänderung ab- und wieder anzumelden.
 */
export function NativePushNavigation() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  useEffect(() => {
    if (!nativePushAvailable()) return;
    let cleanup: (() => void) | undefined;
    let unmounted = false;
    void listenForPushNavigation((url) => navigateRef.current(url)).then((remove) => {
      if (unmounted) remove();
      else cleanup = remove;
    });
    return () => {
      unmounted = true;
      cleanup?.();
    };
  }, []);

  return null;
}
